import React from "react";
import { useIntl } from "react-intl";
import { messages } from "../FurtherMaterials.messages";
import styles from "../FurtherMaterials.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";

interface FurtherMaterials {
  title: string;
}

export const FurtherMaterialsBooks: React.FC<FurtherMaterials> = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();
  return (
    <SimpleLayoutView>
      <div className={styles.FurtherMaterials}>
        <div className={styles.rightComponent}>
          <div className={styles.listsWrapper}>
            <div className={styles.lists}>
              <h4>{formatMessage(messages.G7_P3_G1_Title)}</h4>
              <ul>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I1_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I1_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I1_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I2_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I2_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I2_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I3_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I3_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I3_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I4_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I4_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I4_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I5_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I5_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I5_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I6_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I6_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I6_Link)}
                  </a>
                </li>
                <li>
                  <span>{formatMessage(messages.G7_P3_G1_I7_Title)}</span>
                  <a href="{formatMessage(messages.G7_P3_G1_I7_Link)}" target="_blank" rel="noreferrer">
                    {formatMessage(messages.G7_P3_G1_I7_Link)}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.infoBox}>
            <block.infoBox text={formatMessage(messages.G7_P3_Note)} compact={true} />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
